import { TWidget } from 'widgets/Widget';

/**
 * @description UniversalLink implementation
 * @param Widget Base widget for extending
 * @returns UniversalLink class
 */
function UniversalLinkClassCreator(Widget: TWidget) {
    class UniversalLink extends Widget {
        prefs() {
            return {
                link: '',
                ...super.prefs()
            };
        }

        init(): void {
            super.init();

            if (document.location.hash.includes('universalLink')) {
                let link = this.prefs().link;

                if (link) {
                    const extraSearch = this.getNonRefinementSearch();

                    if (extraSearch) {
                        link += (link.indexOf('?') === -1 ? '?' : '&') + extraSearch;
                    }

                    const el = document.createElement('a');

                    el.href = link;
                    el.innerText = link;
                    document.body.appendChild(el);
                }
            }
        }

        /**
         * @description Returns the current query string without the localized refinement
         * params (prefn/prefv), which the server already provides as universal presentationId
         * values in the link.
         * @returns filtered query string without the leading '?'
         */
        getNonRefinementSearch(): string {
            const search = document.location.search.replace(/^\?/, '');

            if (!search) {
                return '';
            }

            return search
                .split('&')
                .filter(pair => {
                    const key = pair.split('=')[0];

                    return key && !/^pref[nv]\d+$/.test(key);
                })
                .join('&');
        }
    }

    return UniversalLink;
}

export type TUniversalLink = ReturnType<typeof UniversalLinkClassCreator>;

export type TUniversalLinkInstance = InstanceType<TUniversalLink>;

export default UniversalLinkClassCreator;
